import React from 'react'
import './line-clamp.css'

interface LineClampProps<T extends React.ElementType> {
  text?: string
  as?: T
  children?: React.ReactNode
  className?: string
  lines?: number
}

export default function LineClamp<T extends React.ElementType = 'div'>({
  text,
  as,
  children,
  className,
  lines,
  ...props
}: LineClampProps<T>) {
  const Component = as || 'div'
  const linesClass = lines && lines !== 2 ? `line-clamp--${lines}` : ''

  return (
    <Component className={`line-clamp ${linesClass} ${className || ''}`} {...props}>
      {text || children}
    </Component>
  )
}
